import { FC } from 'react'
import { LandingHeroActions } from './LandingHeroActions'
import './LandingFooter.scss'

export const LandingFooter: FC = () => {
  return (
    <div className="LandingFooter">
      <div className="title">Let's cut some audio</div>

      <LandingHeroActions />

      <div className="links">
        <a href="https://audiocutter.online/guides/" target="_blank">
          Guides
        </a>

        <a href="https://audiocutter.online/guides/how-to-cut-audio-file-online/" target="_blank">
          How to cut
        </a>

        <a href="https://audiocutter.online/guides/speeding-up-sound-in-audacity/" target="_blank">
          How to speed up
        </a>
      </div>
    </div>
  )
}
